import { RemoteCursors } from './remote-cursors';
import { RemoteSelectionOutlines } from './remote-selection-outlines';
import { RemoteEdgeHighlights } from './remote-edge-highlights';
import { RemoteInFlightEdges } from './remote-in-flight-edges';
import type { CanvasAwarenessState } from './awareness-types';

interface Bounds {
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface CanvasAwarenessLayerProps {
  remoteStates: Map<number, CanvasAwarenessState>;
  /** Returns flow-space bounds for a node id; null if unknown. */
  nodeBoundsResolver: (id: string) => Bounds | null;
}

/**
 * Engine-side awareness overlay. Both children render through React Flow's
 * `<ViewportPortal>` so coordinates stay in flow-space and React Flow handles
 * the pan/zoom transform automatically.
 */
export function CanvasAwarenessLayer(props: CanvasAwarenessLayerProps) {
  return (
    <>
      <RemoteCursors remoteStates={props.remoteStates} />
      <RemoteSelectionOutlines
        remoteStates={props.remoteStates}
        nodeBoundsResolver={props.nodeBoundsResolver}
      />
      <RemoteEdgeHighlights remoteStates={props.remoteStates} />
      <RemoteInFlightEdges remoteStates={props.remoteStates} />
    </>
  );
}
